export default __webpack_public_path__ + "static/media/cover-image.85565e4e.jpg";